import CreatableSelect from 'react-select/creatable';
import {components} from 'react-select';
import React from 'react';

import './tag-input.css';

type TagInputProps = {
    onChange: (value: string[]) => void;
    data: string[];
    suggestions: string[];
    error: boolean;
    errorMessage: string;
    label: string;
    required: boolean;
    labelStyle: string;
    placeholder: string;
    disabled: boolean;
    indicatorMessage: string | null;
};

const TagInput = ({
    onChange,
    data,
    suggestions,
    error,
    errorMessage = 'Veuillez saisir au moins un tag',
    label = 'Tags',
    required = false,
    labelStyle = 'text-sm text-[#646464] w-36',
    placeholder = 'Tags',
    disabled = false,
    indicatorMessage = null
}: TagInputProps) => {

    const formatCreateLabel = (inputValue: string) => {
        return `Créer "${inputValue}"`;
    };

    return (
        <div>
            <div className='flex items-center'>
                <p className={labelStyle}>
                    {label}
                    {required && <span className='text-red-500'> *</span>}
                </p>
                <CreatableSelect
                    value={data}
                    isMulti
                    name="tags"
                    isDisabled={disabled}
                    options={suggestions}
                    classNamePrefix="tag-input"
                    menuPlacement="auto"
                    menuPosition="fixed"
                    onChange={(newValue) => onChange(newValue as string[])}
                    placeholder={placeholder}
                    formatCreateLabel={formatCreateLabel}
                    components={{ ClearIndicator }}
                    noOptionsMessage={() => 'Aucune option'}
                />
            </div>
            {
                indicatorMessage ?
                    <div
                        dangerouslySetInnerHTML={{__html: indicatorMessage}}
                        className={`text-[#8c8c8c] italic mb-4 text-[13px] ${label ? 'pl-36' : ''}`}
                    /> : null
            }
            {error && <p className='text-xs italic text-red-500'>{errorMessage}</p>}
        </div>
    )
}

export default TagInput;

const ClearIndicator = ({ children, ...props }: any) => (
    <components.ClearIndicator
        {...props}
        innerProps={{
            ...props.innerProps,
            onMouseDown: (e: React.MouseEvent<HTMLDivElement>) => {
                e.stopPropagation();
                props.innerProps.onMouseDown(e);
            }
        }}
    >
        {children}
    </components.ClearIndicator>
);
